import Vue from 'vue'
import axios from 'axios'
import defaultLogo from '@/assets/logo.png'

export const brand = Vue.observable({
  siteLogo: defaultLogo,
  favicon: ''
})

export function resolveBrandAsset(path) {
  if (!path) return ''
  if (/^(https?:)?\/\//i.test(path) || path.startsWith('data:')) return path
  if (path.startsWith(process.env.VUE_APP_BASE_API)) return path
  return process.env.VUE_APP_BASE_API + (path.startsWith('/') ? path : '/' + path)
}

function applyFavicon(path) {
  const href = resolveBrandAsset(path)
  if (!href) return
  let link = document.querySelector("link[rel~='icon']")
  if (!link) {
    link = document.createElement('link')
    link.rel = 'icon'
    document.head.appendChild(link)
  }
  link.href = href
}

export async function loadBrandSettings() {
  try {
    const response = await axios.get(process.env.VUE_APP_BASE_API + '/brand/settings')
    const settings = (response.data && response.data.data) || {}
    brand.siteLogo = resolveBrandAsset(settings.siteLogo) || defaultLogo
    brand.favicon = settings.favicon || ''
    applyFavicon(brand.favicon)
  } catch (error) {
    brand.siteLogo = defaultLogo
  }
  return brand
}
